// extracted by mini-css-extract-plugin
export default {"brandPromo":"eH-z","carousel":"fH-z"};